export enum ExternalAnswersEnum {
  HOME = '1',
  AWAY = '2',
  DRAW = 'X'
}

export enum ExternalAnswersNamesEnum {
  HOME_TEAM = 'HOME_TEAM',
  AWAY_TEAM = 'AWAY_TEAM',
  DRAW = 'DRAW'
}
